import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CategoryPageComponent } from "src/components/pages/category-page/category-page.component";
import { CheckoutPageComponent } from "src/components/pages/checkout-page/checkout-page.component";
import { CookieInfoPageComponent } from "src/components/pages/cookie-info-page/cookie-info-page.component";
import { FaqPageComponent } from "src/components/pages/faq-page/faq-page/faq-page.component";
import { NotFoundPageComponent } from "src/components/pages/not-found-page/not-found-page.component";
import { ProductPageComponent } from "src/components/pages/product-page/product-page.component";
import { SearchPageComponent } from "src/components/pages/search-page/search-page.component";
import { StartPageComponent } from "src/components/pages/start-page/start-page.component";
import { TermsPageComponent } from "src/components/pages/terms-page/terms-page.component";
import { ThankYouPageComponent } from "src/components/pages/thank-you-page/thank-you-page.component";
import themes from "src/domain/themes";

const childRoutes: Routes = [
  {
    path: "",
    component: StartPageComponent,
    data: {
      [Symbol.for("TBO:HIDE_CAR_OR_NO_DEALER_WARNING")]: true,
    },
  },
  {
    path: "faq",
    component: FaqPageComponent,
    data: {
      [Symbol.for("TBO:HIDE_CAR_OR_NO_DEALER_WARNING")]: true,
    },
  },
  {
    path: "product/:sku",
    component: ProductPageComponent,
  },
  {
    path: "search",
    component: SearchPageComponent,
  },
  {
    path: "terms",
    component: TermsPageComponent,
    data: {
      [Symbol.for("TBO:HIDE_CAR_OR_NO_DEALER_WARNING")]: true,
    },
  },
  {
    path: "cookies",
    component: CookieInfoPageComponent,
    data: {
      [Symbol.for("TBO:HIDE_CAR_OR_NO_DEALER_WARNING")]: true,
    },
  },
  {
    path: "thank-you/:shoppingCartId",
    component: ThankYouPageComponent,
  },
  {
    path: "category/:categoryId/:slug",
    component: CategoryPageComponent,
  },
  {
    path: "checkout",
    component: CheckoutPageComponent,
  },
];

const routes: Routes = [
  {
    path: "**",
    component: NotFoundPageComponent,
  },
];

themes.forEach((t) => {
  routes.unshift({ path: t, children: childRoutes });
});

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: "enabled",
      anchorScrolling: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class RoutingModule {}
